$(function () {
    /*
    $('.active-menu-item').closest('.sidebar-full').find('li.sidebar-dropdown').removeClass('d-none').addClass('d-block active');
    $('.active-menu-item').closest('.sidebar-full').find('ul.sidebar-submenu').removeClass('d-none').addClass('d-block active');
    */

    /*
    $('.active-menu-item').parents('li.sidebar-dropdown').removeClass('d-none').addClass('d-block active');
    $('.active-menu-item').parents('ul.sidebar-submenu').removeClass('d-none').addClass('d-block active');
    */

    /*
    $('.active-menu-item').parents('li.sidebar-dropdown').filter(function () {
        return $(this).closest('.sidebar-full').length > 0;
    }).removeClass('d-none').addClass('d-block active');


    $('.active-menu-item').parents('ul.sidebar-submenu').filter(function () {
        return $(this).closest('.sidebar-full').length > 0;
    }).removeClass('d-none').addClass('d-block active');
    

    $('#main_menu.sidebar-collapsed').find('ul.sidebar-menu > li ul.sidebar-submenu').removeClass('active d-block').addClass('d-none');

    */

    /*
    $('a.link-to-menu').click(function (e) {
        e.preventDefault();
    });
    */

    $('.active-menu-item').parents('li.sidebar-dropdown').filter(function () {
        return $(this).closest('.sidebar-full').length > 0;
    }).show();


    $('.active-menu-item').parents('ul.sidebar-submenu').filter(function () {
        return $(this).closest('.sidebar-full').length > 0;
    }).show();

    $('#main_menu.sidebar-collapsed').find('ul.sidebar-menu > li ul.sidebar-submenu').removeClass('active').hide();
    

    // Toggle menu state
    $('#collapse_menu').click(function () {

        if ($('#main_menu').hasClass('sidebar-full')) {
            // At this point the menu need to collapse
            $('#main_menu').removeClass('sidebar-full').addClass('sidebar-collapsed');
            Cookies.set('is_menu_collapsed', 1);
            $(this).find('span').removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
            $('#main_menu').find('li.sidebar-dropdown').removeClass('active').hide();
            $('#main_menu').find('ul.sidebar-submenu').removeClass('active').hide();

            // only show the first node!
            $('ul.sidebar-menu > li.sidebar-dropdown').show();

        } else {
            // At this point the menu need to show in a full size mode
            $('#main_menu').removeClass('sidebar-collapsed').addClass('sidebar-full');
            Cookies.set('is_menu_collapsed', 0);
            $(this).find('span').removeClass('fa-angle-double-right').addClass('fa-angle-double-left');

            $('.active-menu-item').parents('li.sidebar-dropdown').addClass('active').show();
            $('.active-menu-item').parents('ul.sidebar-submenu').addClass('active').show();
        }
    });

    // Dropdown menu
    $('.sidebar-dropdown > a').click(function (e) {
        e.preventDefault();
        var link = $(this);

        var url = link.attr('href');

        if (link.hasClass('link-to-url') && url !== '#') {
            window.location.replace(url);

            return false;
        }

        var item = link.parent();

        //var nextSubMenu = item.find("ul.sidebar-submenu").first();

        var nextSubMenu = $(this).next("ul.sidebar-submenu");

        if (item.hasClass("active")) {
            nextSubMenu.slideUp(200);
            //nextSubMenu.hide();
            item.removeClass("active");
        } else {
            nextSubMenu.slideDown(200);
            //nextSubMenu.show();
            item.addClass("active");
        }

    });
    

});
